import React, { useState } from "react";
import { useProSidebar } from "react-pro-sidebar";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
const WorkerParticipation = () => {
  const { collapseSidebar, collapsed } = useProSidebar();
  const [rows, setRows] = useState([{ value: "" }]);

  const handleAddRow = () => {
    setRows([...rows, { value: "" }]);
  };

  const handleChange = (event, index) => {
    const newRows = [...rows];
    newRows[index].value = event.target.value;
    setRows(newRows);
  };
  const removeRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  const [formData, setFormData] = useState({
    legalForm: "",
    natureofOwnership: "",
    headquarters: "",
    countriesOfOperation: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission or file upload logic here
  };

  return (
    <>
      <div className="flex justify-between items-center shadow-md border-gray-100">
        <div
          className={`${
            collapsed ? "w-[80%] " : "w-[75%]"
          } flex justify-between items-center`}
        >
          <div className="text-left mb-5 ml-6 mt-4">
            <p className="text-sm">Social</p>
            <p className="gradient-text text-[22px]">
              Worker Involvement in OHS
            </p>
          </div>
          <div className="flex  absolute right-[4.5rem] mt-3">
            <button className="text-[#007EEF] bg-slate-200 rounded-full text-[11px] w-[60px] h-[25px]">
              GRI 302-1
            </button>
            <button className="text-[#fff] bg-amber-400 rounded-full text-[11px] w-[60px] h-[25px] ml-2 ">
              SDG 7
            </button>
            <button className="text-[#fff] bg-red-900 rounded-full text-[11px] w-[60px] h-[25px] ml-2">
              SDG 8
            </button>
            <button className="text-[#fff] bg-yellow-600 rounded-full text-[11px] w-[60px] h-[25px] ml-2 ">
              SDG 12
            </button>
            <button className="text-[#fff] bg-lime-900 rounded-full text-[11px] w-[60px] h-[25px] ml-2">
              SDG 13
            </button>
          </div>
        </div>
      </div>
      <div className={`${
                collapsed ? "w-[85%] " : "w-[75%]"
              } mt-6` }>
        {/* <h1 className="mx-4 pt-4 font-semibold">2 text-xs.2 text-xs</h1> */}

        <form onSubmit={handleSubmit}>
          <div className="flex items-center mx-4 pb-2 mb-4">
            <div>
              <label htmlFor="legalForm" className="block  mb-1 pb-4">
                <h2 className="text-gray-600 text-[15px]">
                  Is there a processes for worker participation and consultation
                  in the development, implementation, and evaluation of the
                  occupational health and safety management system?
                </h2>
              </label>
              <select
                // id="natureofOwnership"
                name="natureofOwnership"
                className="mt-2 p-2 border rounded-md w-full"
                // value={formData.natureofOwnership}
                // onChange={handleInputChange}
              >
                <option value="select">- Select - </option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
          </div>

          <div className="flex items-center mx-4 pb-2  mb-4">
            <div
              className={`${
                collapsed ? "w-[84%] " : "w-[75%]"
              } mb-5 text-xs text-start`}
            >
              <label htmlFor="legalForm" className="block  mb-1 pb-4">
                <h2 className="text-gray-600 text-[15px]">
                  If yes, Describe the process and how access is provided to
                  relevant information on occupational health and safety to
                  workers
                </h2>
              </label>
              <div className="border custom-scrollbar rounded-md shadow-md">
                <div className="mb-5 text-xs text-start overflow-x-scroll">
                  <table className="w-full rounded-md px-2 mb-5">
                    <thead className="h-[30px] pb-5 border gradient-background mb-2">
                      <tr className="space-x-2 ">
                        <th className="text-left pl-3 py-2">
                          Formal joint management-worker health and safety
                          committees
                        </th>
                        <th className="text-left pl-3">Responsibilities</th>
                        <th className="text-left pl-3">Meeting Frequency </th>
                        <th className="text-left pl-3 ">
                          Decision-making authority
                        </th>
                        <th className="text-left pl-3">
                          Workers not represented in the committee
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody className="mt-2 mb-3">
                      {rows.map((row, index) => (
                        <tr key={index} className="mt-3">
                          <td>
                            <select
                              className="block w-[210px]  mx-2 py-2 mt-4 pl-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 border-b border-gray-300"
                              value={row.value}
                              onChange={(event) => handleChange(event, index)}
                            >
                              <option>- Select -</option>
                              <option>- Commitee 1 -</option>
                            </select>
                          </td>
                          <td>
                            <select
                              className="block w-[210px]  mx-2 py-2 mt-4 pl-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 border-b border-gray-300"
                              value={row.value}
                              onChange={(event) => handleChange(event, index)}
                            >
                              <option>- Select -</option>
                              <option>- Commitee 1 -</option>
                            </select>
                          </td>
                          <td>
                            <select
                              className="block w-[210px]  mx-2 py-2 mt-4 pl-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 border-b border-gray-300"
                              value={row.value}
                              onChange={(event) => handleChange(event, index)}
                            >
                              <option>- Select -</option>
                              <option>- Commitee 1 -</option>
                            </select>
                          </td>

                          <td className="">
                            <select
                              className="block w-[210px]  mx-2 py-2 mt-4 pl-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 border-b border-gray-300"
                              value={row.value}
                              onChange={(event) => handleChange(event, index)}
                            >
                              <option>- Select -</option>
                              <option>- Commitee 1 -</option>
                            </select>
                          </td>
                          <td>
                            <select
                              className="block w-[210px]  mx-2 py-2 mt-4 pl-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 border-b border-gray-300"
                              value={row.value}
                              onChange={(event) => handleChange(event, index)}
                            >
                              <option>- Select -</option>
                              <option>- Commitee 1 -</option>
                            </select>
                          </td>
                          <td>
                            {" "}
                            <DeleteOutlineIcon
                              className="text-red-600 cursor-pointer"
                              onClick={() => removeRow(index)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button
                    className="mb-2 text-blue-600 font-bold py-2 px-4 mx-2 rounded text-xs opacity-70 border border-[#007EEF]"
                    onClick={handleAddRow}
                  >
                    Add new row +
                  </button>
                </div>
              </div>

            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default WorkerParticipation;
